import createSingle from "./create-single.js";
import getSingle from "./get-single.js";
import getMultiple from "./get-multiple.js";
import deleteSingle from "./delete-single.js";
import updateSingle from "./update-single.js";

export default {
	createSingle,
	getSingle,
	getMultiple,
	deleteSingle,
	updateSingle,
};
